module.exports = __webpack_public_path__ + "img/scene4.93b27b08.png";